/* eslint-disable react-hooks/exhaustive-deps */
import React, { useCallback, useEffect, useState } from "react";
import { Avatar, Button, Card, Collapse, List, Spin, Typography } from "antd";
import { isValidElement, isValidString } from "../../util/ApiHelper";
import { useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { CERT_KEY } from "../../util/Constant";
import {
  isExporter,
  isBuyer,
  isCHA,
  isManufacturerCumExporter,
  isFreightCreditUser,
  isFreightForwarder,
  isCustomhouseagentsCumFreightforwarder
} from "./../../util/helper";
import { isVerifiedFreightEligible } from "../../util/helper";
import VerificationBanner from "../home/setup/VerificationBanner";
import ProfileUpdatePasswordModal from "./ProfileUpdatePasswordModal";
import { resetPasswordToken } from "../../appRedux/actions/authAction";
import { useGetBreakpoints } from "../../hooks/useGetBreakpoints";
import MyBalance from "./MyBalance";
import MyActivity from "./MyActivity";
import PaymentHistory from "./PaymentHistory";
import axios from "axios";
import { axiosInstance, BASE_API_CONFIG } from "../../util/Api";
import { getUpdatedPoints } from "../../appRedux/actions/pointsAction";
import AddUserModel from "./AddUserModel";
import { message } from "antd";
import MySubscription from "./MySubscription";
import SecondaryUsers from './SecoundaryUsers'

import MyRatings from "./MyRatings";
import { Panel } from "react-instantsearch-dom";
import { DownOutlined, TeamOutlined } from "@ant-design/icons";
import {
  notifyWalletSummaryUpdated,
  useWalletSummary,
} from "../../hooks/useWalletSummary";
import VerifiedFreightTag from "../../components/VerifiedFreightTag";

export const getAttchementByKey = (user, key) => {
  if (isValidElement(user?.attachments)) {
    return user?.attachments.find((attachment) => attachment.key === key);
  }
};

const MyProfileView = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const { isMobile } = useGetBreakpoints();
  const authUser = useSelector(({ auth }) => auth.userData);
  const isFreightUser = isFreightCreditUser(authUser);
  console.log("authUser",authUser)
  const [showUpdatePasswordModal, setShowUpdatePasswordModal] = useState(false);
  const userData = useSelector(({ auth }) => auth?.userData);
  const [pointsData, setPointsData] = useState([]);
  const [paymentData, setPaymentData] = useState([]);
  const uuid = authUser?.uuid;
  const { refresh: refreshWalletSummary, ...walletSummary } = useWalletSummary();
  const [showAddUserModal, setShowAddUserModal] = useState(false);
  const [userCount, setUserCount] = useState(0);
  const userId = authUser.id;
  const token = authUser.token;
  const [ratingDetails, setRatingDetails] = useState([]);

  const [currentSubscription, setCurrentSubscription] = useState(null);
  console.log("currentSubscription",setCurrentSubscription)
  const [isLoadingSubscription, setIsLoadingSubscription] = useState(false);



  // ========== NEW STATES FOR FREIGHT FORWARDERS ==========
  const [myFreights, setMyFreights] = useState([]);
  const [loadingFreights, setLoadingFreights] = useState(false);
  const [freightNotes, setFreightNotes] = useState("");
  // =======================================================

  // ========== NEW STATES FOR MY EXPORTERS (FREIGHT FORWARDERS) ==========
  const [myExporters, setMyExporters] = useState([]);
  const [loadingExporters, setLoadingExporters] = useState(false);
  // =====================================================================

  // Fetch my freight forwarders
  const fetchMyFreights = useCallback(async () => {
    if (!isExporter(authUser)) return;
    
    try {
      setLoadingFreights(true);
      const response = await axiosInstance.get(
        `${BASE_API_CONFIG.baseURL}/users/${authUser?.id}/myfreights`
      );
      const myFreightsData = response.data.data || [];
      setMyFreights(myFreightsData);
      
      // Extract notes if available
      if (myFreightsData.length > 0 && myFreightsData[0].notes) {
        setFreightNotes(myFreightsData[0].notes);
      }
    } catch (error) {
      console.error("Error fetching my freights:", error);
      message.error("Failed to load freight forwarders");
    } finally {
      setLoadingFreights(false);
    }
  }, [authUser]);

  useEffect(() => {
    if (isExporter(authUser)) {
      fetchMyFreights();
    }
  }, [authUser, fetchMyFreights]);

  // Fetch exporters who added me as their freight forwarder
  const fetchMyExporters = useCallback(async () => {
    const isFreightUser =
      isFreightForwarder(authUser) ||
      isCustomhouseagentsCumFreightforwarder(authUser);
    if (!isFreightUser) return;

    try {
      setLoadingExporters(true);
      const response = await axiosInstance.get(
        `${BASE_API_CONFIG.baseURL}/users/${authUser?.id}/myexporters`
      );
      const myExportersData = response.data.data || [];
      setMyExporters(myExportersData);
    } catch (error) {
      console.error("Error fetching my exporters:", error);
      message.error("Failed to load exporters");
    } finally {
      setLoadingExporters(false);
    }
  }, [authUser]);

  useEffect(() => {
    const isFreightUser =
      isFreightForwarder(authUser) ||
      isCustomhouseagentsCumFreightforwarder(authUser);
    if (isFreightUser) {
      fetchMyExporters();
    }
  }, [authUser, fetchMyExporters]);


  const handleFreightForwarderClick = (freightUserId) => {
  if (freightUserId) {
    history.push(`/user-profile?id=${freightUserId}`);
  } else {
    message.warning("Unable to view freight forwarder details");
  }
};

  const handleExporterClick = (exporterUserId) => {
    if (exporterUserId) {
      history.push(`/user-profile?id=${exporterUserId}`);
    } else {
      message.warning("Unable to view exporter details");
    }
  };

  // ========== RENDER FREIGHT FORWARDERS IN LIST ==========
  // ========== RENDER FREIGHT FORWARDERS IN LIST (CLEAN VERTICAL) ==========
const renderFreightForwardersValue = () => {
  if (!isExporter(authUser)) return "Not applicable";
  
  if (loadingFreights) {
    return <Spin size="small" />;
  }
  
  if (myFreights.length === 0) {
    return (
      <div>
        <Typography.Text type="secondary">No freight forwarders added</Typography.Text>
      </div>
    );
  }
  
  return (
    <div>
      <div style={{ 
        maxHeight: 200, 
        overflowY: 'auto',
        padding: '4px 0',
        fontSize: '13px'
      }}>
        {myFreights.map((item, index) => {
          const freightData = item.freight || {
            companyName: item.freightCompanyName,
            id: item.freightId, // Make sure we have the ID
            verifiedFreight: item.verifiedFreight,
          };
          const companyName = freightData.companyName || freightData.name || 'Unknown';
          const freightUserId = freightData.id || item.freightId;
          
          return (
            <div 
              key={item.freightId} 
              style={{
                padding: '6px 0',
                borderBottom: index < myFreights.length - 1 ? '1px dashed #f0f0f0' : 'none',
                whiteSpace: 'normal',
                wordBreak: 'break-word'
              }}
            >
              <Typography.Link 
                onClick={() => handleFreightForwarderClick(freightUserId)}
                style={{
                  color: '#1890ff',
                  cursor: 'pointer',
                  textDecoration: 'underline',
                  fontWeight: 500
                }}
              >
                {companyName}
              </Typography.Link>
              {isVerifiedFreightEligible(freightData) && (
                <VerifiedFreightTag
                  verifiedFreight={freightData?.verifiedFreight}
                  style={{ marginLeft: 8 }}
                />
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
};

const renderMyExportersValue = () => {
  const isFreightUser =
    isFreightForwarder(authUser) ||
    isCustomhouseagentsCumFreightforwarder(authUser);
  if (!isFreightUser) return "Not applicable";

  if (loadingExporters) {
    return <Spin size="small" />;
  }

  if (myExporters.length === 0) {
    return (
      <div>
        <Typography.Text type="secondary">
          No exporters have added you yet
        </Typography.Text>
      </div>
    );
  }

  return (
    <div>
      <div
        style={{
          maxHeight: 200,
          overflowY: "auto",
          padding: "4px 0",
          fontSize: "13px",
        }}
      >
        {myExporters.map((item, index) => {
          const exporterData = item.exporter || {
            companyName: item.exporterCompanyName,
            id: item.exporterId,
          };
          const companyName =
            exporterData.companyName ||
            exporterData.name ||
            item.companyName ||
            "Unknown";
          const exporterUserId = exporterData.id || item.exporterId;

          return (
            <div
              key={exporterUserId || item.id || index}
              style={{
                padding: "6px 0",
                borderBottom:
                  index < myExporters.length - 1
                    ? "1px dashed #f0f0f0"
                    : "none",
                whiteSpace: "normal",
                wordBreak: "break-word",
              }}
            >
              <Typography.Link
                onClick={() => handleExporterClick(exporterUserId)}
                style={{
                  color: "#1890ff",
                  cursor: "pointer",
                  textDecoration: "underline",
                  fontWeight: 500,
                }}
              >
                {companyName}
              </Typography.Link>
            </div>
          );
        })}
      </div>
    </div>
  );
};




  const fetchPointsData = useCallback(async () => {
    if (!isFreightUser) {
      setPointsData([]);
      return;
    }

    try {
      if (uuid) {
        let response;
        try {
          response = await axios.get(
            `${BASE_API_CONFIG.baseURL}/wallet/history/${uuid}`
          );
        } catch (walletError) {
          response = await axios.get(
            `${BASE_API_CONFIG.baseURL}/pointshistory/${uuid}`
          );
        }

        const rows = response?.data?.data?.rows || response?.data?.data || [];
        const formattedData = rows.map((point, index) => ({
          key: point.id || index,
          date: new Date(
            point.transactiondate || point.createdAt || new Date()
          ).toLocaleDateString(),
          transactionname:
            point.transactionname || point.description || "Wallet activity",
          transactiontype: point.transactiontype || point.type || "DR",
          pointsconsumed:
            point.pointsconsumed ?? point.amount ?? point.debitAmount ?? 0,
          hostPaymentid: point.hostpaymentid || point.paymentId || "-",
          status: point.status || "-",
        }));
        setPointsData(formattedData);
      }
    } catch (err) {
      console.error("Error fetching points data:", err);
    }
  }, [isFreightUser, uuid]);

  useEffect(() => {
    if (uuid) {
      dispatch(getUpdatedPoints({ uuid }));
      fetchPointsData();
    }
  }, [uuid, dispatch, fetchPointsData]);

  const fetchPaymenthistory = useCallback(async () => {
  if (!isFreightUser || !uuid) {
    setPaymentData([]);
    return;
  }

  try {
    let walletRows = [];
    let paymentHistoryRows = [];
    try {
      const response = await axios.get(
        `${BASE_API_CONFIG.baseURL}/wallet/payments/${uuid}`
      );
      walletRows = response?.data?.data?.rows || response?.data?.data || [];
    } catch (walletError) {
      if (walletError?.response?.status !== 404) {
        console.error("Error fetching wallet payments:", walletError);
      }
    }

    try {
      const response = await axios.get(
        `${BASE_API_CONFIG.baseURL}/paymenthistory/${uuid}`
      );
      paymentHistoryRows =
        response?.data?.data?.rows || response?.data?.data || [];
    } catch (paymentHistoryError) {
      if (paymentHistoryError?.response?.status !== 404) {
        console.error("Error fetching payment history:", paymentHistoryError);
      }
    }

    const rows = [...walletRows, ...paymentHistoryRows];

    const normalizedRows = rows.map((point, index) => ({
      key: point.id || point.hostpaymentid || point.paymentId || index,
      transactiondate: new Date(
        point.transactiondate || point.createdAt || new Date()
      ).toLocaleDateString(),
      description: point.transactionname || point.description || "Add Funds",
      currency: point.currency || walletSummary.currency,
      hostPaymentid: point.hostpaymentid || point.paymentId || "-",
      status: point.status || "-",
      transactionamount: point.transactionamount ?? point.amount ?? 0,
      displayAmount:
        point.displayAmount ??
        point.amount ??
        point.transactionamount ??
        0,
      createdAt: point.createdAt || point.transactiondate || "",
    }));

    const formattedData = Array.from(
      new Map(
        normalizedRows.map((point) => {
          const dedupeKey = [
            point.hostPaymentid,
            point.transactiondate,
            point.description,
            point.transactionamount,
            point.status,
          ].join("__");
          return [dedupeKey, point];
        })
      ).values()
    ).sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));

    setPaymentData(formattedData);
  } catch (error) {
    console.error("Error fetching payment history:", error);
    setPaymentData([]);
  }
}, [isFreightUser, uuid, walletSummary.currency]);



  const getPortData = (portValue, label) => {
    if (!portValue) return { label, value: '', isEmpty: true };
    
    let formattedValue;
    if (Array.isArray(portValue)) {
      formattedValue = portValue.filter(Boolean).join(", ");
    } else if (typeof portValue === 'string') {
      formattedValue = portValue.replace(/[\[\]"]/g, '').replace(/,/g, ', ');
    } else {
      formattedValue = 'Invalid format';
    }
  
    return {
      label,
      value: formattedValue,
      isEmpty: !formattedValue || formattedValue === ''
    };
  };
  const refreshBalance = () => {
    if (uuid && isFreightUser) {
      dispatch(getUpdatedPoints({ uuid }));
      fetchPointsData();
      fetchPaymenthistory();
      refreshWalletSummary();
      notifyWalletSummaryUpdated();
    }
  };

  useEffect(() => {
    if (uuid && isFreightUser) {
      dispatch(getUpdatedPoints({ uuid }));
      fetchPaymenthistory();
    }
  }, [uuid, dispatch, fetchPaymenthistory, isFreightUser]);

  useEffect(() => {
    dispatch(resetPasswordToken());
  }, []);

  const fetchRatings = async () => {
    try {
      const response = await axios.get(
        `${BASE_API_CONFIG.baseURL}/ratings/myProfile/${userId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      setRatingDetails(response.data.data.ratings);
    } catch (error) {
      console.error("Error getting rating:", error);
    }
  };

  useEffect(() => {
    fetchRatings();
  }, [userId]);

  const getAttachments = () => {
    if (isBuyer(authUser)) {
      const certificate = getAttchementByKey(
        authUser,
        CERT_KEY.COMPANY
      )?.originalName;

      return certificate ? (
        <a
          href={getAttchementByKey(authUser, CERT_KEY.COMPANY)?.src}
          download
          target="_blank"
          rel="noreferrer"
        >
          {certificate}
        </a>
      ) : (
        "Not available"
      );
    } else if (isExporter(authUser)) {
      const certificate = getAttchementByKey(
        authUser,
        CERT_KEY.GST
      )?.originalName;

      return certificate ? (
        <a
          href={getAttchementByKey(authUser, CERT_KEY.GST)?.src}
          download
          target="_blank"
          rel="noreferrer"
        >
          {certificate}
        </a>
      ) : (
        "Not available"
      );
    }else if (!isExporter(authUser) && !isBuyer(authUser)) {
      const certificate = getAttchementByKey(
        authUser,
        CERT_KEY.GST
      )?.originalName;

      return certificate ? (
        <a
          href={getAttchementByKey(authUser, CERT_KEY.GST)?.src}
          download
          target="_blank"
          rel="noreferrer"
        >
          {certificate}
        </a>
      ) : (
        "Not available"
      );
    } else {
      return "Not available";
    }
  };

  const getEximCertificate = () => {
    const certificate = getAttchementByKey(
      authUser,
      CERT_KEY.EXIM
    )?.originalName;

    if (isExporter(authUser)) {
      return certificate ? (
        <a
          href={getAttchementByKey(authUser, CERT_KEY.EXIM)?.src}
          download
          target="_blank"
          rel="noreferrer"
        >
          {certificate}
        </a>
      ) : (
        "Not available"
      );
    }
  };
  const companyId = authUser.companyId;
  const gstNumber = authUser.gstNumber;

  const handleAddUser = async (values) => {
    try {
      const response = await axiosInstance.post(
        `${BASE_API_CONFIG.baseURL}/users/add`,
        {
          email: values.email,
          password: values.password,
          companyId,
          gstNumber,
          requirePasswordChange: true,
        }
      );
      console.log("email", response);

      if (response.data.success) {
        message.success(
          "User added successfully. A verification email has been sent."
        );
      } else {
        throw new Error(response.data.message);
      }
    } catch (error) {
      throw new Error("Failed to add user.");
    }
  };


  const formatPortPairs = (portPairs) => {
    if (!portPairs) return [];
    
    try {
      const pairsArray = Array.isArray(portPairs) 
        ? portPairs 
        : portPairs.replace(/[\[\]"]/g, '').split(',');
      
      return pairsArray.map(pair => {
        const [loading, destination] = pair.split('→').map(s => s.trim());
        return { loading, destination };
      });
    } catch (error) {
      console.error("Error formatting port pairs:", error);
      return [];
    }
  };

   const renderPortPairs = () => {
    const portPairs = formatPortPairs(authUser?.portPairs);
    if (portPairs.length === 0) return "Not available";
    
    return (
      <div style={{ whiteSpace: 'pre-line' }}>
        {portPairs.map((pair, index) => (
          <div key={index}>
            {pair.loading} → {pair.destination}
            {index < portPairs.length - 1 && ','}
          </div>
        ))}
      </div>
    );
  };

  const data = [
    {
      label: "Name",
      value: authUser?.name,
    },
    {
      label: "Company",
      value: authUser?.companyName,
    },
    {
      label: "Phone",
      value: authUser?.mobile,
    },
    {
      label: "Email",
      value: authUser?.email,
    },
    {
      label: "Website Link",
      value: (<a
        href={authUser?.website}
        target="_blank"
        rel="noopener noreferrer">
        {authUser?.website}
      </a>
      )
    },
    {
      label: "City",
      value: authUser?.city,
    },
    {
      label: "Country",
      value: authUser?.country,
    },
    {
      label: "Description",
      value: authUser?.companyDescription,
    },
    {
      label: "GST Number",
      value: authUser?.gstNumber,
    },
    {
      label: isBuyer(authUser) ? "Company Certificate" : "GST Certificate",
      value: getAttachments(),
    },
    ...(isExporter(authUser) ? [{
      label: "EXIM Certificate",
      value: getEximCertificate()  
    }] : [] ),

    ...(( isCHA(authUser) || isCustomhouseagentsCumFreightforwarder(authUser))  //|| isFreightForwarder(authUser) 
    ? [
        getPortData(
          authUser?.loadingPort,
          isCHA(authUser) || isCustomhouseagentsCumFreightforwarder(authUser) ? "CHA Handling Ports" : "Handling Ports"
        ),
        // getPortData(authUser?.port, "Destination Ports")
      ]
    : []),
     ...((isExporter(authUser)) 
    ? [{
         label: "Loading and Destination Ports",
        value: <Typography.Text style={{ fontSize: 12 }}>{renderPortPairs()}</Typography.Text>
      }]
    : []),
     ...(isExporter(authUser) ? [{
      label: "My Freight Forwarders",
      value: renderFreightForwardersValue()
    }] : []),
    ...((isFreightForwarder(authUser) ||
      isCustomhouseagentsCumFreightforwarder(authUser))
      ? [
          {
            label: "My Exporters",
            value: renderMyExportersValue(),
          },
        ]
      : []),
  ];
  const navigateProfileEdit = () => {
    history.push(`/my-profile/edit`);
  };

  const openUpdatePasswordModal = () => {
    setShowUpdatePasswordModal(true);
  };

  return (
    isValidElement(authUser) && (
      <div>
        <div>
          {authUser?.status !== "approved" && (
            <VerificationBanner showButton={false} />
          )}
          <Card className="myexim-detail-card">
            {/* <div className="myexim-table-title">
            My Profile
          </div> */}
            <div
              className={`logo-with-list gx-mt-4 ${
                isMobile ? "gx-flex-column" : ""
              }`}
            >
              <div style={{ paddingRight: 16 }}>
                {isValidString(authUser?.companyLogo) && (
                  <div className={"logo-container"}>
                    <div className={"logo-image"}>
                      <img
                        alt="..."
                        src={authUser?.companyLogo}
                        width={isMobile ? "100%" : 120}
                        height={isMobile ? "100%" : 120}
                      />
                    </div>
                  </div>
                )}
              </div>
              <div style={{ flex: 1 }}>
                <List
                  itemLayout="horizontal"
                  dataSource={data}
                  renderItem={(item) => (
                    <List.Item className="myexim-details-list">
                      <List.Item.Meta
                        key={item.label}
                        title={<div>{item.label}</div>}
                        description={
                          isValidString(item.value) ? item.value : "-"
                        }
                      />
                    </List.Item>
                  )}
                />
              </div>
            </div>
            <div
              style={{
                justifyContent: isMobile ? "center" : "end",
                display: "flex",
                flex: 1,
                flexWrap: "wrap",
              }}
              className="gx-pt-4"
            >
              {/* <Button
                type="primary"
                size="large"
                htmlType="submit"
                onClick={openUpdatePasswordModal}
                className="submit-btn"
              >
                Change Password
              </Button> */}
              <Button
                type="primary"
                size="large"
                htmlType="submit"
                onClick={navigateProfileEdit}
                className="submit-btn"
              >
                Edit
              </Button>
             
            </div>
            {showUpdatePasswordModal ? (
              <ProfileUpdatePasswordModal
                showModal={showUpdatePasswordModal}
                onCancel={() => {
                  dispatch(resetPasswordToken());
                  setShowUpdatePasswordModal(false);
                }}
              />
            ) : null}
          </Card>
          {isFreightUser && (
            <MyBalance
              walletSummary={walletSummary}
              refreshBalance={refreshBalance}
            />
          )}
{!(isBuyer(authUser) || isFreightForwarder(authUser) || isCustomhouseagentsCumFreightforwarder(authUser))  && (
  <>
    <MySubscription 
      currentSubscription={currentSubscription}
    />
  </>
)}

{ !isBuyer(authUser) && authUser.isPrimary && 
  <SecondaryUsers 
    primaryUserId={authUser.id}  // Changed from companyId to id
    isPrimaryUser={authUser.isPrimary}  // Direct boolean value
  />
}
           {!isFreightUser && <PaymentHistory paymentData={paymentData} />}

           {isFreightUser && (
             <MyActivity pointsData={pointsData} paymentData={paymentData} />
           )}

           {  !isExporter(authUser) &&

          <MyRatings ratingDetails={ratingDetails} />
           }
        </div>
      </div>
    )
  );
};

export default MyProfileView;
